import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';

export const RENEWED_TOKEN_HEADER = 'X-Renewed-Token';
export const RENEWED_TOKEN_EXP_HEADER = 'X-Renewed-Token-Exp';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add auth header with jwt if user is logged in and request is to the api url
    const currentUser = this.authenticationService.currentUserValue;
    const isLoggedIn = currentUser && currentUser.token;
    const isApiUrl = request.url.startsWith(environment.baseServerURL);
    if (isLoggedIn && isApiUrl) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.token}`
        }
      });
    }
    if (!isApiUrl) {
      return next.handle(request);
    }
    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.applyRenewedToken(event);
        }
      })
    );
  }

  private applyRenewedToken(response: HttpResponse<any>): void {
    const token = response.headers.get(RENEWED_TOKEN_HEADER);
    const exp = Number(response.headers.get(RENEWED_TOKEN_EXP_HEADER));
    if (token && exp > 0) {
      this.authenticationService.updateToken(token, exp);
    }
  }
}
